import React from 'react';
import ReadMailContain from '../../Componant/Email/ReadMail';

const EmailRead = () => {
  return (
    <div className='page-body'>
      <ReadMailContain />
    </div>
  );
};

export default EmailRead;
